import React from "react";
import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import ForgotPassword from "../pages/auth/forgotPassword/ForgotPassword";
import Login from "../pages/auth/login/Login";
import ResetCode from "../pages/auth/resetCode/ResetCode";
import SignUp from "../pages/auth/signUp/SignUp";
import VerificationCode from "../pages/auth/verificationCode/VerificationCode";
import Applications from "../pages/dashboard/applications/Applications";
import Dashboard from "../pages/dashboard/dashboard/Dashboard";
import Documents from "../pages/dashboard/documents/Documents";
import Profile from "../pages/dashboard/profile/Profile";
import Support from "../pages/dashboard/support/Support";
import ProtectedRouteIn from "./ProtectedRouteIn";
import ProtectedRouteOut from "./ProtectedRouteOut";
import CreateNewPassword from "pages/auth/createNewPassword/CreateNewPassword";
import Faq from "pages/dashboard/faq/Faq";
import Home from "pages/dashboard/home/Home";
// import PropertyListing from "pages/dashboard/PropertyListing/PropertyListing";
import Prequalification from "pages/dashboard/prequalification/Prequalification";

export const StackS = () => {
  const { isLoggedIn } = useContext(AuthContext);
  return (
    <Routes>
      <Route path={"/"} exact element={<Home />} />
      {/* <Route path={"/property_listings"} exact element={<PropertyListing />} /> */}
      <Route path={"/prequalification"} exact element={<Prequalification />} />

      <Route
        path={"/login"}
        exact
        element={
          <ProtectedRouteIn auth={isLoggedIn}>
            <Login />
          </ProtectedRouteIn>
        }
      />
      <Route
        path={"/signup"}
        exact
        element={
          <ProtectedRouteIn auth={isLoggedIn}>
            <SignUp />
          </ProtectedRouteIn>
        }
      />

      <Route path={"/verification"} exact element={<VerificationCode />} />
      <Route path={"/forgot-password"} exact element={<ForgotPassword />} />
      <Route path={"/reset-code"} exact element={<ResetCode />} />
      <Route
        path={"/create-new-password"}
        exact
        element={<CreateNewPassword />}
      />

      <Route
        path={"/dashboard"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <Dashboard />
          </ProtectedRouteOut>
        }
      />

      <Route
        path={"/profile"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <Profile />
          </ProtectedRouteOut>
        }
      />
      <Route
        path={"/applications"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <Applications />
          </ProtectedRouteOut>
        }
      />
      <Route
        path={"/documents"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <Documents />
          </ProtectedRouteOut>
        }
      />
      {/* <Route
        path={"/mortgage-calc"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <MortgageCalc />
          </ProtectedRouteOut>
        }
      /> */}
      {/* <Route
        path={"/property-listing"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <PropertyListings />
          </ProtectedRouteOut>
        }
      /> */}
      <Route
        path={"/contact-us"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <Support />
          </ProtectedRouteOut>
        }
      />
      <Route
        path={"/faq"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <Faq />
          </ProtectedRouteOut>
        }
      />
      <Route
        path={"/profile"}
        exact
        element={
          <ProtectedRouteOut auth={isLoggedIn}>
            <Profile />
          </ProtectedRouteOut>
        }
      />
    </Routes>
  );
};